
import request from "@/components/request";

export default {
  install(app) {
    app.config.globalProperties.$request = request;
  },
};